import {mediaStrings as MEDIA_STRINGS} from '@wandb/weave/common/types/media';
import memoize from 'memoize-one';

import {type RunHistoryKeyInfo} from '../../../types/run';
import * as RunHelpers from '../../../util/runhelpers';
import {type KeyTypes} from '../common';

function getMediaKeysImpl(keyInfo: RunHistoryKeyInfo): {
  allMediaKeys: string[];
  defaultKeys: string[] | undefined;
  keyTypes: KeyTypes;
  numericKeys: string[];
} {
  const keyTypes = RunHelpers.keyTypes(keyInfo.keys);

  const allMediaKeys = RunHelpers.keysOfType(keyTypes, MEDIA_STRINGS);
  const defaultKeys = allMediaKeys.length > 0 ? [allMediaKeys[0]] : undefined;
  const numericKeys = RunHelpers.keysOfType(keyTypes, ['number']);

  return {
    allMediaKeys,
    defaultKeys,
    keyTypes,
    numericKeys,
  };
}

export const getMediaKeys = memoize(getMediaKeysImpl);

export function getMediaKeysDisplayStringParts(mediaKeys: string[]): {
  type: 'element' | 'literal';
  value: string;
}[] {
  // casting to `any` avoids the ts(2339) error for ListFormat not existing on Intl
  // likely can be removed if we upgrade to a more recent target version
  const formatter = new (Intl as any).ListFormat('en', {
    style: 'long',
    type: 'conjunction',
  });
  return formatter.formatToParts(mediaKeys);
}
